export const SET_SELECTED_FORM = 'SET_SELECTED_FORM';

export const GLOBAL_FORM_ID = 'globalForm';
export const OD_FORM_ID = 'odForm';

export const FORM_TYPES = Object.freeze({
  GLOBAL: 'global',
  OD: 'od',
});